var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.4824,
    cy: 48.6396,
    r: 48.1514,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.4824,
    cy: 48.6396,
    r: 46.8382,
    stroke: "#7C684E",
    strokeOpacity: 0.26,
    strokeWidth: 2.62644
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4496 66.8053C26.6679 66.3536 26.3957 65.3497 26.8971 64.5985C29.0206 61.4176 31.8498 58.7608 35.1723 56.8408C38.9675 54.6475 43.2727 53.4929 47.6551 53.4929C52.0374 53.4929 56.3426 54.6475 60.1378 56.8408C63.4603 58.7608 66.2896 61.4176 68.413 64.5985C68.9144 65.3497 68.6422 66.3536 67.8605 66.8053C67.0788 67.257 66.0843 66.9848 65.5755 66.2386C63.744 63.5529 61.329 61.307 58.5035 59.6742C55.2052 57.7681 51.4637 56.7646 47.6551 56.7646C43.8465 56.7646 40.1049 57.7681 36.8066 59.6742C33.9811 61.307 31.5661 63.5529 29.7347 66.2386C29.2258 66.9848 28.2313 67.257 27.4496 66.8053Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3977 40.9984C57.3977 35.7809 53.1721 31.5513 47.9595 31.5513C42.747 31.5513 38.5214 35.7809 38.5214 40.9984C38.5214 46.2159 42.747 50.4455 47.9595 50.4455V53.4929C41.0655 53.4929 35.4768 47.8989 35.4768 40.9984C35.4768 34.0979 41.0655 28.5039 47.9595 28.5039C54.8536 28.5039 60.4423 34.0979 60.4423 40.9984C60.4423 47.8989 54.8536 53.4929 47.9595 53.4929V50.4455C53.1721 50.4455 57.3977 46.2159 57.3977 40.9984Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.9b36b83f99d29d037b540f42190897e2.svg";
export { ForwardRef as ReactComponent };